<template>
  <footer>
    <div class="footer_container">
      <div class="footer_content">
        <div>
          <ul class="help-wrap row-flex-wrap">
            <li>
              <a
                :title="t('footer.about')"
                rel="nofollow"
                target="_blank"
                href="/about/1.html">
                {{ t('footer.about') }}
              </a>
            </li>
            <li>
              <a
                :title="t('footer.help')"
                rel="nofollow"
                target="_blank"
                href="/about/3.html">
                {{ t('footer.help') }}
              </a>
            </li>
            <li>
              <a
                :title="t('footer.contact')"
                rel="nofollow"
                target="_blank"
                href="/about/2.html">
                {{ t('footer.contact') }}
              </a>
            </li>
            <li>
              <a
                :title="t('footer.highpay')"
                rel="nofollow"
                target="_blank"
                href="/about/4.html">
                {{ t('footer.highpay') }}
              </a>
            </li>
            <li>
              <a
                :title="t('footer.agreement')"
                rel="nofollow"
                target="_blank"
                href="/about/5.html">
                {{ t('footer.agreement') }}
              </a>
            </li>
            <li>
              <a
                :title="t('footer.payment')"
                rel="nofollow"
                target="_blank"
                href="/about/6.html">
                {{ t('footer.payment') }}
              </a>
            </li>
            <li style="visibility: hidden">
              <a
                :title="t('footer.cooperation')"
                rel="nofollow"
                target="_blank"
                href="/cooperation.html">
                {{ t('footer.cooperation') }}
              </a>
            </li>
          </ul>
          <div class="other-info">
            <span>
              <a
                href="http://beian.miit.gov.cn/"
                rel="nofollow,noindex"
                target="_blank">
                {{ t('footer.ICP_recordNum') }}
              </a>
            </span>
            <span>
                <i class="iconfont el-icon-yyzz"></i>
            </span>
            <span>
              <img
                alt="police"
                rel="nofollow,noindex"
                src="https://img.alicdn.com/tfs/TB17Ss8ASBYBeNjy0FeXXbnmFXa-20-20.png"
                loading="lazy" />
            </span>
            <span>
              <a
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33011002013432ç"
                rel="nofollow,noindex">
                {{ t('footer.networkSecurity') }}
              </a>
            </span>
          </div>
        </div>
        <client-only>
          <media-box />
        </client-only>
        <div class="contact-content">
          <div class="top">
            <span
              class="but"
              @click="handleShowJoin">
              {{ t('footer.us_collaborate') }}
            </span>
            <!-- <a @click="openkefu()" title="在线客服">
                <i class="el-icon-contact" />
                在线客服
              </a> -->
            <span class="but">
              <a
                :title="t('footer.customer')"
                href="JavaScript:KS.openDirChatWin()"
                rel="nofollow,noindex">
                {{ t('footer.customer') }}
              </a>
            </span>
          </div>
          <div
            v-if="lang !== ELocale.en"
            class="tel">
            <div class="tel-icon">
              <i class="el-icon-tel" />
            </div>
            <div class="tel-text">
              <!-- <div class="tel-num"></div> -->
              <div class="tel-num">{{ t('footer.booth_consult') }}：0571-88560061</div>
              <div class="tel-num">{{ t('footer.viewer_consult') }}：0571-88683357</div>
              <div class="work-time">{{ t('footer.work_time') }} 9:00-18:00</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="globalStore.links && showLinks && visibleLinks"
      class="link-container">
      <div class="link-content">
        <div class="$style.title">{{ t('footer.friendship_link') }}</div>
        <ul class="link-list">
          <li
            v-for="item in globalStore.links"
            :key="item.id">
            <a
              :href="item.url"
              :title="item.name"
              target="_blank">
              {{ item.name }}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <Join
      v-if="joinVisible"
      :visible="joinVisible"
      @close="handleCloseJoin" />
  </footer>
</template>

<script lang="ts" setup>
  import { defineAsyncComponent, onMounted, ref } from 'vue'
  import { ELocale } from '~~/types/enums'

  const MediaBox = defineAsyncComponent(() => import('~/components/MediaBox/index.vue'))
  const Join = defineAsyncComponent(() => import('~/components/Join/index.vue'))

  interface Props {
    visibleLinks?: boolean
  }

  const props = withDefaults(defineProps<Props>(), {
    visibleLinks: false
  })

  const route = useRoute()
  const globalStore = useGlobalStore()
  const i18nStore = useI18nStore()
  const { t } = useI18n()
  const joinVisible = ref(false)
  const isSdkReady = ref(false)

  const lang = i18nStore.locale

  const showLinks = (() => {
    const { path, params } = route
    const firstIndustryId = params.f || '0'
    const secondIndustryId = params.s || '0'
    const area = params.g || '0'
    const province = params.p || '0'
    const city = params.c || '0'
    const date = params.t || '0'

    if (/\/exhibition[-\d+]/.test(path)) {
      return (
        +firstIndustryId > 0 &&
        +secondIndustryId >= 0 &&
        (+area === 0 || +area === 1) &&
        +province === 0 &&
        +city === 0 &&
        +date === 0
      )
    } else return path === '/'
  })()

  const init = () => {
    // window.ysf('onready', () => {
    //   isSdkReady.value = true;
    // });
  }

  const openkefu = () => {
    if (isSdkReady.value) {
      ;(window as any).ysf('open')
    }
  }

  const handleShowJoin = () => {
    joinVisible.value = true
  }

  const handleCloseJoin = () => {
    joinVisible.value = false
  }

  onMounted(init)
</script>

<style lang="less" scoped>
  .footer_container {
    background: #191c21;
    padding: 56px 0;

    .footer_content {
      width: 1190px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;

      .help-wrap {
        margin-bottom: 30px;
        display: flex;

        li {
          margin-bottom: 10px;
          padding: 0 18px;
          border-right: 1px solid #7f7f7f;
          line-height: 1;

          a {
            color: #fff;
          }

          &:first-child {
            padding: 0 18px 0 0;
          }

          &:last-child {
            border-right: none;
          }
        }
      }

      .other-info {
        font-size: 14px;
        color: #fff;
        margin-bottom: 8px;
        display: flex;
        align-items: center;

        a {
          color: #fff;
        }

        span {
          height: 20px;
          display: inline-flex;
          align-items: center;
          margin-right: 7px;

          img {
            width: auto;
            height: 20px;
          }
        }

        &:last-child {
          margin-bottom: 0;
        }
      }

      .contact-content {
        width: 240px;
        flex-shrink: 0;
        color: #fff;
        line-height: 1;
        margin-left: 32px;

        .top {
          margin-bottom: 14px;
          display: flex;

          .but {
            display: inline-block;
            width: 100px;
            line-height: 12px;
            font-size: 14px;
            padding: 8px 0;
            border-radius: 4px;
            background: 0 0;
            text-align: center;
            cursor: pointer;
            border: 1px solid #fff;

            &:first-child {
              margin-right: 20px;
              cursor: pointer;

              &:hover {
                color: @app-color;
              }
            }
          }

          a {
            color: #fff;
          }
        }

        .tel {
          display: flex;

          &-icon {
            padding-top: 4px;
          }

          &-text {
            line-height: 24px;

            > div {
              font-size: 16px;
              //font-family: Arial-BoldMT, Arial, sans-serif;
            }
          }

          .work-time {
            font-size: 14px;
            font-weight: 400;
            color: #fff;
          }
        }

        [class*=' el-icon-'],
        [class^='el-icon-'] {
          margin-right: 6px;
        }
      }
    }
  }

  .link-container {
    background: #191c21;
    color: #fff;
    font-size: 12px;

    .link-content {
      width: 1190px;
      margin: 0 auto;
      padding: 0 0 22px 0;

      .title {
        margin-bottom: 8px;
      }

      .link-list {
        display: flex;
        flex-wrap: wrap;
        margin: 0;

        li {
          margin-right: 8px;

          a {
            color: #fff;
            line-height: 24px;
          }
        }
      }
    }
  }
</style>
